var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Courses',{attrs:{"courses":_vm.courses,"router-link":_vm.routerLink}})}
var staticRenderFns = []

export { render, staticRenderFns }